var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.9126 16.2261L11.2509 11.3358C12.4399 10.1329 13.1765 8.47463 13.1765 6.64577C13.1765 2.9811 10.2212 0 6.58827 0C2.95531 0 0 2.9811 0 6.64577C0 10.3104 2.95531 13.2915 6.58827 13.2915C8.18295 13.2915 9.64649 12.7165 10.7872 11.7624L15.4602 16.6648C15.5217 16.7296 15.6039 16.7619 15.6864 16.7619C15.7648 16.7619 15.8429 16.7325 15.9038 16.6736C16.0286 16.5524 16.0324 16.3521 15.9126 16.2261ZM6.58827 12.6586C3.30135 12.6586 0.627455 9.96138 0.627455 6.64577C0.627455 3.33017 3.30135 0.632931 6.58827 0.632931C9.8752 0.632931 12.5491 3.33017 12.5491 6.64577C12.5491 9.96138 9.87488 12.6586 6.58827 12.6586Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.503f39a7f1963ee92ee72126d6ac27bc.svg";
export { ForwardRef as ReactComponent };